"use strict";
var toPrimitive = require("../internals/to-primitive");
var isSymbol = require("../internals/is-symbol");
module.exports = function(argument) {
  var key = toPrimitive(argument, "string");
  return isSymbol(key) ? key : key + "";
};
